module.exports = {
	"id": "GL",
	"name": "Greenland",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.006176,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.012352,
			"30": null,
			"31": null,
			"32": 0.104992,
			"33": null,
			"34": 0.086464,
			"35": 0.012352,
			"36": null,
			"37": null,
			"38": null,
			"39": 0.067936,
			"40": 0.006176,
			"41": null,
			"42": 0.037056,
			"43": 0.67936,
			"44": 0.006176,
			"45": 0.012352,
			"46": 0.018528,
			"47": 0.012352,
			"48": 0.006176,
			"49": 0.9264,
			"50": 0.049408,
			"51": 0.290272,
			"52": 0.24704,
			"53": 13.852768,
			"54": 4.366432,
			"55": 0.024704,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.074112,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.012352,
			"39": null,
			"40": 0.012352,
			"41": 0.006176,
			"42": 0.018528,
			"43": 0.043232,
			"44": 0.067936,
			"45": 0.055584,
			"46": 0.037056,
			"47": 0.568192,
			"48": 0.457024,
			"49": 4.545536,
			"50": 0.024704,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 14.797696
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.006176,
			"37": 0.012352,
			"38": 0.1544,
			"39": null,
			"40": 0.284096,
			"41": 0.055584,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": 0.006176,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.03088
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.006176,
			"6": null,
			"7": 0.043232,
			"8": 0.21616,
			"9": 0.728768,
			"10": 2.309824,
			"3.1": null,
			"3.2": null,
			"5.1": 0.098816,
			"6.1": 0.067936,
			"7.1": null,
			"9.1": 1.334016
		},
		"ios_saf": {
			"8": 0,
			"10": 8.39902277435,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.226343945046,
			"8.1-8.4": 0.418160847627,
			"9.0-9.2": 0.199489578684,
			"9.3": 3.04349485429
		},
		"android": {
			"3": 0,
			"4": 0.0342381395349,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00427976744186,
			"4.1": 0.123501860465,
			"4.2-4.3": 0.308754651163,
			"4.4": 0.707995813953,
			"4.4.3-4.4.4": 0.714109767442
		},
		"ie": {
			"6": null,
			"7": 0.037056,
			"8": 0.166752,
			"9": 0.327328,
			"10": 0.352032,
			"11": 9.270176,
			"5.5": null
		},
		"op_mob": {
			"0": 0.329377731062,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0091493814184
		},
		"edge": {
			"12": 0.395264,
			"13": 0.784352,
			"14": 2.637152
		},
		"ie_mob": {
			"10": 0.0490118309859,
			"11": 0.199548169014
		},
		"bb": {
			"7": 0.001912,
			"10": null
		},
		"samsung": {
			"0": 4.393776
		},
		"and_uc": {
			"0": 5.456848
		},
		"op_mini": {
			"0": 4.43764888752
		},
		"and_chr": {
			"0": 9.400192
		},
		"and_ff": {
			"0": 0.030592
		}
	},
	"total": 99.358104
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GL.json
 ** module id = 532
 ** module chunks = 0
 **/